<!-- Единая адаптивная группа текстовых действий внутри карточки записи. -->
<template>
  <div class="base-card-actions" role="group" :aria-label="label">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCardActions",

  props: {
    label: {
      type: String,
      default: "Действия с записью",
    },
  },
};
</script>

<style scoped>
.base-card-actions {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

@media (max-width: 768px) {
  .base-card-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(min(120px, 100%), 1fr)
    );
  }

  .base-card-actions > :deep(button) {
    width: 100%;
    min-width: 0;
    min-height: 40px;
    height: auto;
    white-space: normal;
  }
}
</style>
